import clsx from '@/lib/clsx';

const WizardSectionHeader = ({ children, className = '', style = {}, ...props }) => {
  return (
    <div className={clsx('comp-wizard-section-header', className)} style={style} {...props}>
      {children}
    </div>
  );
};

export default WizardSectionHeader;
